import { render, staticRenderFns } from "./SMSChecker.vue?vue&type=template&id=4205f540&scoped=true"
import script from "./SMSChecker.vue?vue&type=script&lang=js"
export * from "./SMSChecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4205f540",
  null
  
)

export default component.exports